"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EmbedOnlyModal;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _theme = _interopRequireDefault(require("../../theme"));
var _media = _interopRequireDefault(require("../../media"));
var _BaseModal = _interopRequireDefault(require("./BaseModal"));
var _CircleIcon = _interopRequireDefault(require("../CircleIcon"));
var _IconClose = _interopRequireDefault(require("../Icon/IconClose"));
const _excluded = ["children", "onChangeVisible"];
const StyledModal = (0, _styledComponents.default)(_BaseModal.default)`
  .ant-modal-body {
    padding: 0 !important;
  }
`;
const CloseCircleIcon = (0, _styledComponents.default)(_CircleIcon.default).attrs({
  className: 'close-circle-icon'
})`
  && {
    position: absolute;
    top: -34px;
    right: 0;
    cursor: pointer;
    z-index: 10;

    ${_media.default.desktop`
      top: 0;
      right: -34px;
    `}
  }
`;
function EmbedOnlyModal(_ref) {
  let {
      children,
      onChangeVisible
    } = _ref,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(StyledModal, (0, _extends2.default)({
    key: "modal",
    onChangeVisible: onChangeVisible,
    centered: true
  }, others), children, /*#__PURE__*/_react.default.createElement(CloseCircleIcon, {
    type: "info",
    size: "medium",
    background: _theme.default.colors.black,
    key: "close-circle-icon",
    onClick: e => {
      // antd is dumb and doesn't stopPropagation
      // https://stackoverflow.com/a/62956176
      e.stopPropagation();
      onChangeVisible(false);
    }
  }, /*#__PURE__*/_react.default.createElement(_IconClose.default, null)));
}
EmbedOnlyModal.propTypes = {
  children: _propTypes.default.node,
  onChangeVisible: _propTypes.default.func
};